import { LISTAR_CATTIPOCORTECAJA } from "../../types";

export default (state, action) => {
  switch (action.type) {
    case LISTAR_CATTIPOCORTECAJA:
      return {
        ...state,
        tipoCorteCaja: action.payload,
      };
    default:
      return state;
  }
};
